<template>
    <b-modal v-model="isShowPopup" dialog-class="modal-detail" @hidden="resetModal" scrollable :no-close-on-backdrop=true id="popup-upload" @ok="finishAction" :okTitle="'X'" title="Berita Acara Stock Opname">

			<app-table-input-popup title="Berita Acara Stock Opname" :bordered="true" :items="beritaAcaraStockOpnames" :fields="fields" :busy="isDataLoading" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" small responsive
			@editButtonMethod="defaultMethod"
			@deleteButtonMethod="defaultMethod"
			@showPopupAddMethod="defaultMethod()"
			@showPopupUploadMethod="defaultMethod()"
			@downloadMethod="defaultMethod()"
			@addFromClipboardMethod="defaultMethod()"
			@replaceFromClipboardMethod="defaultMethod()"
			:showActionButton="false"
			:showEditButton="false"
			:showDeleteButton="false"
			:showAddButton="false"
			:showAddFromClipboardButton="false"
			:showReplaceFromClipboardButton="false"
			:showUploadButton="false"
			:showDownloadButton="false"
			:isDownloadBusy="isDownloadBusy"
			>
			<template #top-row v-if="isShowFilter">
				<b-th></b-th>
				<b-th stacked-heading="Area" class="table-filter">
					<v-select append-to-body label="code" :options="areas" :value="filter.areaId" :reduce="item => item.id" v-model="filter.areaId" :filterable="true" @input="getBeritaAcaraStockOpnamesWithoutLoading" @search="getAreas"></v-select>
				</b-th>
				<b-th stacked-heading="Vendor" class="table-filter">
					<v-select append-to-body label="code" :options="vendors" :value="filter.vendorId" :reduce="item => item.id" v-model="filter.vendorId" :filterable="true" @input="getBeritaAcaraStockOpnamesWithoutLoading" @search="getVendors"></v-select>
				</b-th>
				<b-th></b-th>

					</template>
				<template v-slot:head(no)>
					<b-button @click="isShowFilter = !isShowFilter" size="sm" class="btn-filter float-right"><b-icon-funnel /></b-button>
				</template>
			<template v-slot:cell(front-action)="row">
			</template>
			<template v-slot:cell(no)="row">
						{{ ((row.index + 1) + ( pageSizeOptions * (currentPage - 1))) }}
			</template>
			<template v-slot:table-busys>
				<div class="text-center my-2">
					<b-spinner class="align-middle text-primary"></b-spinner>
					<strong class="ml-2">Loading...</strong>
				</div>
			</template>
			<template v-slot:cell(stockOpnamePlan)="row">
				{{ row.item.stockOpnamePlan != null ? row.item.stockOpnamePlan.name : "" }}
			</template>
			<template v-slot:cell(area)="row">
				{{ row.item.area != null ? row.item.area.code : "" }}
			</template>
			<template v-slot:cell(vendor)="row">
				{{ row.item.vendor != null ? row.item.vendor.code : "" }}
			</template>
			<template v-slot:cell(remarks)="row">
				<app-input-textarea id="fieldset-remarks" label-cols-lg="12"  label="Remarks" label-for="input-remarks" size="sm" :model.sync="row.item.remarks"  @change="saveInputBeritaAcara(row.item)" :isUpdatable="false" :isEditable="!row.item.isStockOpnamed"/>
				<!-- <app-label :model="'Sudah Dilakukan Stock Opname'" label="" :nolabel="true" v-if="row.item.isStockOpnamed" /> -->
			</template>

			<template v-slot:edit-button></template>
		</app-table-input-popup>
        <template #modal-footer="{ ok, cancel }">
			<b-button class="btn-create btn-fill-success" @click="finishAction()" size="sm"> <b-icon-plus-square class="mr-1"></b-icon-plus-square>Finish</b-button>
            <b-button size="sm" variant="secondary" class="float-right" @click="cancel()">
                Cancel
            </b-button>
        </template>
        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </b-modal>
</template>
<style lang="scss" scoped>
    .card {
        border: 1px solid rgba(0, 0, 0, 0.125) !important;
    }

    ::v-deep.th-message {
        color: red;
    }

    ::v-deep.modal-footer {
        display: block;
    }
</style>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import { saveAs } from 'file-saver';

import StockOpnamePlan from '@/models/StockOpnamePlan/StockOpnamePlan';
import StockOpnamePlanList from '@/models/StockOpnamePlan/StockOpnamePlanList';
import StockOpnamePlanFilter from '@/filters/StockOpnamePlan/StockOpnamePlanFilter';
import AppTableInputPopup from '@/components/AppTableInputPopup';
import BeritaAcaraStockOpname from '@/models/BeritaAcaraStockOpname/BeritaAcaraStockOpname';
import BeritaAcaraStockOpnameFilter from '@/filters/BeritaAcaraStockOpname/BeritaAcaraStockOpnameFilter';
import AppInputTextarea from '@/components/AppInputTextarea';
import AppLabel from '@/components/AppLabel';
import AreaFilter from '@/filters/Area/AreaFilter';
import Area from '@/models/Area/Area';
import VendorFilter from '@/filters/Vendor/VendorFilter';
import Vendor from '@/models/Vendor/Vendor';


export default {
	props: ['model', 'stockOpnamePlanId','openPopup','uploadButtonMethod', 'parentId','okTitle'],
	components : {AppTableInputPopup,BeritaAcaraStockOpname,BeritaAcaraStockOpnameFilter,AppInputTextarea,AppLabel},
	data() {
		return {
			uploadProcessId: null,
			datas: Array(),

			busy:false,
			isDataLoading: false,
			isBusy : false,
			stockOpnamePlans : [],
			stockOpnamePlansFailed: [],
			sortByStockOpnamePlan: '',
			sortDescStockOpnamePlan: '',
			hasFailedDataStockOpnamePlan: false,
			totalFailedStockOpnamePlan: 0,
			totalSucceedStockOpnamePlan: 0,

			processId: '',
			isUploadSuccess: false,
			sortBy:'',
			sortingBy:[],
			sortDesc:'',
			isShowBeritaAcaraFilter: false,
			isDownloadBusy: false,
			isShowFilter: false,
			beritaAcaraStockOpnames:[],
			fields: [
				// {"front-action": { "class" : "th-front-action", "label" : ""}},
				{"no" : {"class" : "th-number d-stack-none"}},
				// {"stockOpnamePlan": {}, "class" : "th-stock-opname-plan first-child", "label" : "Stock Opname Plan", key: 'stockOpnamePlan', sortable: true}, 
				{"area": {}, "class" : "th-area first-child", "label" : "Area", key: 'area', sortable: false}, 
				{"vendor": {}, "class" : "th-vendor last-child", "label" : "Vendor", key: 'vendor', sortable: false}, 
				{"remarks": {}, "class" : "th-remarks d-stack-none", "label" : "Remarks", key: 'remarks', sortable: false}, 
				{"actions": {"class" : "th-actions d-stack-show", "label" : ""}}
			],
			pageSizeOptions: 9999,
			currentPage: 1,
			vendors : [],
			areas : [],
		}
	},
	methods : {
		getAreas : async function(input) {
			let filter = new AreaFilter();
			if (input != undefined) {
				filter.code = input;
			}
			if(this.filter.areaId != undefined && input == '')
			{
				filter.id = this.filter.areaId;
			}
			await Area.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.areas = result.data
				}
			})
			.catch(error => {});
		},
		getVendors : async function(input) {
			let filter = new VendorFilter();
			if (input != undefined) {
				filter.code = input;
			}
			if(this.filter.vendorId != undefined && input == '')
			{
				filter.id = this.filter.vendorId;
			}
			filter.vendorTypeCode = "SUBCONTRACT";
			await Vendor.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.vendors = result.data
				}
			})
			.catch(error => {});
		},
		getBeritaAcaraStockOpnamesWithoutLoading : async function() {
			if (this.stockOpnamePlanId==''||this.stockOpnamePlanId==null) {
				return;
			}
			this.sortingBy = Array();
			
			this.sortingBy['createddate'] = 1;
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}
			this.filter.stockOpnamePlanId = this.stockOpnamePlanId;
			this.filter.isStockOpnamed = false;
			BeritaAcaraStockOpname.getList(this, this.filter, this.sortingBy,(this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.beritaAcaraStockOpnames = result.data
				}
			});
		},
		getBeritaAcaraStockOpnames : async function() {
			if (this.stockOpnamePlanId==''||this.stockOpnamePlanId==null) {
				return;
			}
			this.isDataLoading = true;
			this.sortingBy = Array();
			
			this.sortingBy['createddate'] = 1;
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}
			this.filter.stockOpnamePlanId = this.stockOpnamePlanId;
			this.filter.isStockOpnamed = false;
			BeritaAcaraStockOpname.getList(this, this.filter, this.sortingBy,(this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.beritaAcaraStockOpnames = result.data
				}
				this.isDataLoading = false;
			})
			.catch(error => {
				this.isDataLoading = false;
			});
		},
		defaultMethod(){
			return;
		},
		saveInputBeritaAcara(item){
			let id = item.id;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					BeritaAcaraStockOpname.updateData(this, item, item.id);
				}
			});
		},
		generateBeritaAcaraFromStockOpnamePlan(){
			let StoPlanId = this.stockOpnamePlanId;
			let this_ = this;
			this_.$http.post('StockOpnamePlan/generateberitaacarasto/' + StoPlanId)
			.then(async function(response){
				this_.getBeritaAcaraStockOpnames();
			})
			.catch(function(error){
				this_.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			});
		},
		finishAction() {
			
			let StoPlanId = this.stockOpnamePlanId;
			if (StoPlanId==''||StoPlanId==null) {
				return
			}
			const msg = this.$createElement;
			const msgNode = msg('div', {
				domProps: {
					innerHTML: '<p>Apakah anda yakin untuk menyelesaikan Proses Stock Opname ?</p>'
				}
			});
			this.$bvModal.msgBoxConfirm([msgNode], {
				title: 'Confirmation',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'success',
				cancelVariant: 'danger',
				okTitle: 'Yes',
				cancelTitle: 'No',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			})
			.then(async value => {
				if (value) {
					let this_ = this;
					this_.$http.post('StockOpnamePlan/finishStockOpname/' + StoPlanId)
					.then(async function(response){
						this_.resetModal()
					})
					.catch(function(error){
						this_.$store.dispatch('addErrorMessageGlobal', error);
						throw error;
					});
				}
			})
			.catch(err => {})
		},
		resetModal() {
			this.beritaAcaraStockOpnames = Array();
			this.$emit('resetMethod');
		},
	},
	beforeMount() {
		this.filter = new BeritaAcaraStockOpnameFilter();
	},
	mounted(){
		this.getVendors();
		this.getAreas();
		this.getBeritaAcaraStockOpnames();
	},
	watch: {
		openPopup(newValue,oldValue) {
			if (newValue) {
				this.generateBeritaAcaraFromStockOpnamePlan();
			} else {
				this.beritaAcaraStockOpnames=[];
			}
		},
	},
	computed: {
		isShowPopup : {
			get: function () {
				if (this.openPopup) {
					return true;
				}
				else return false;
			},
			set: function (newValue) {}
		},
	}
}
</script>
